import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CustomDotCmsContentlet } from 'src/app/extensions/dot-cms/models/contentlet/custom-dotcms-contentlet.model';
import { parseJsonToHtml } from 'src/app/extensions/dot-cms/utils/Block-editor/dot-cms-block-editor-utils';

@Component({
  selector: 'custom-dot-cms-block-editor-table',
  templateUrl: './dot-cms-block-editor-table.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DotCmsBlockEditorTableComponent implements OnInit {
  content!: CustomDotCmsContentlet;
  htmlContent = '';

  ngOnInit() {
    this.htmlContent = parseJsonToHtml(this.content);
  }
}
